const SmallLoader = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "2.2rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px",
        marginTop: "-1vh"
      }}
    >
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          style={{
            width: "8px",
            height: "8px",
            background: "#000",
            borderRadius: "50%",
            animation: `bounce 0.6s infinite ${i * 0.15}s`
          }}
        />
      ))}

      <style>
        {`
          @keyframes bounce {
            0%, 80%, 100% { transform: translateY(0); opacity: 0.3; }
            40% { transform: translateY(-6px); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};


export default SmallLoader;